module.exports = __webpack_public_path__ + "operace-ocnich-vicek-dolni_1_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-ocnich-vicek-dolni_1_before.jpg
// module id = 1146
// module chunks = 0